// Misc
import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import orderBy from 'lodash/orderBy'
import groupBy from 'lodash/groupBy'
import clone from 'lodash/clone'
import isArray from 'lodash/isArray'
import some from 'lodash/some'

// Components
import WeekDays from './WeekDays'
import ItemsGrid from './ItemsGrid'

export default class ScheduleEditor extends Component {
  static propTypes = {
    schedule: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    addFormTitle: PropTypes.string.isRequired,
    editFormTitle: PropTypes.string.isRequired,
  }

  static getDerivedStateFromProps = (nextProps, prevState) => {
    if (nextProps.schedule !== prevState.schedule) {
      return {
        schedule: nextProps.schedule,
        weekDayItems: ScheduleEditor.getWeekDayItems(nextProps.schedule)
      }
    }
    return null
  }

  static getWeekDayItems(schedule) {
    return groupBy(schedule, 'weekDay')
  }

  constructor({ schedule }) {
    super()
    this.state = {
      schedule, // eslint-disable-line
      weekDayItems: ScheduleEditor.getWeekDayItems(schedule)
    }
  }

  triggerChange = (nextSchedule) => {
    const { onChange } = this.props

    // Check overlapping times
    const hasOverlaps = some(
      nextSchedule,
      (a, indexA) => some(
        nextSchedule,
        (b, indexB) => (
          indexA !== indexB
          && a.weekDay === b.weekDay
          && a.startTimeMinute < (b.endTimeMinute || b.startTimeMinute)
          && (a.endTimeMinute || a.startTimeMinute) > b.startTimeMinute
        )
      )
    )

    if (hasOverlaps) {
      throw new Error('You can\'t add overlapping times on the same day')
    }

    const nextScheduleOrdered = orderBy(nextSchedule, ['startTimeMinute', 'endTimeMinute'])
    onChange(nextScheduleOrdered)
  }

  replaceItem = (item, nextItem) => {
    const { schedule } = this.props
    const itemIndex = schedule.indexOf(item)
    const nextSchedule = clone(schedule)
    if (nextItem) {
      nextSchedule.splice(itemIndex, 1, nextItem)
    } else {
      nextSchedule.splice(itemIndex, 1)
    }
    this.triggerChange(nextSchedule)
  }

  handleItemAdd = (newItem) => {
    const { schedule } = this.props
    const nextSchedule = schedule.concat(isArray(newItem) ? newItem : [newItem])
    this.triggerChange(nextSchedule)
  }

  handleItemDelete = (item) => {
    this.replaceItem(item)
  }

  renderWeekDays() {
    const { addFormTitle, editFormTitle } = this.props
    const { weekDayItems } = this.state
    return (
      <WeekDays
        weekDayItems={weekDayItems}
        onItemAdd={this.handleItemAdd}
        addFormTitle={addFormTitle}
        editFormTitle={editFormTitle}
      />
    )
  }

  renderItemsGrid() {
    const { addFormTitle, editFormTitle } = this.props
    const { weekDayItems } = this.state
    return (
      <ItemsGrid
        weekDayItems={weekDayItems}
        onItemAdd={this.handleItemAdd}
        onItemChange={this.replaceItem}
        onItemDelete={this.handleItemDelete}
        addFormTitle={addFormTitle}
        editFormTitle={editFormTitle}
      />
    )
  }

  render() {
    return (
      <Fragment>
        { this.renderWeekDays() }
        { this.renderItemsGrid() }
      </Fragment>
    )
  }
}
